























import Vue from 'vue'
import gql from 'graphql-tag'
import { Component, Prop, Watch, Emit } from 'vue-property-decorator'

import AppDialog from '@/components/AppDialog.vue'

import { ApolloResponse } from '@/interfaces/apollo'
import { showErrors } from '@/utils/snack'
import { ReducedUser } from '@/modules/User/interfaces/user'
import AppListSelector from '@/components/AppListSelector.vue'

@Component({
  components: {
    AppDialog,
    AppListSelector
  }
})
export default class AssignToDialogDialog extends Vue {
  @Prop(Boolean) readonly value!: boolean
  @Prop({ type: String }) readonly title!: string
  @Prop({ type: Boolean }) readonly disable!: boolean
  @Prop({ type: Array }) readonly assignedUsers!: ReducedUser[]

  showDialog = false

  checkedIndex: number[] = []

  staff: ReducedUser[] = []

  get staffNames () {
    return this.staff.map(staff => staff.username)
  }

  mounted () {
    this.getStaff()
  }

  @Watch('value')
  async valueChanged (val: boolean) {
    this.showDialog = val

    if (val === true) {
      const checkedIndex = this.assignedUsers.map(user => {
        return this.staff.findIndex(staff => staff.id === Number(user.id))
      })
      this.checkedIndex = checkedIndex
    }
  }

  async getStaff () {
    try {
      const result: ApolloResponse = await this.$apollo.query({
        query: gql`
          query {
            getAllUsers {
              id
              username
            }
          }
        `
      })
      this.staff = result.data.getAllUsers
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  @Emit('confirm')
  onConfirm () {
    return this.checkedIndex.map(i => this.staff[i].id)
  }

  @Emit('cancel')
  onCancel () {
    this.showDialog = false
  }
}
